import assign = require('object-assign');
import { 
    FETCH_INVENTORY_REQUEST,
    FETCH_INVENTORY_SUCCESS,
    FETCH_INVENTORY_FAILURE,
} from '../../constants/MAV';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch(action.type) {
        case FETCH_INVENTORY_REQUEST:
        case FETCH_INVENTORY_SUCCESS:
        case FETCH_INVENTORY_FAILURE:
            return true;
        default:
            return false;
    }
}


export default function inventory(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_INVENTORY_REQUEST: {
            return assign({}, state, {
                inventory: {
                    loading: true
                }
            });
        }
        case FETCH_INVENTORY_SUCCESS: {
            return assign({}, state, {
                inventory: {
                    loading: false,
                    data: action.payload
                }
            });
        }
        case FETCH_INVENTORY_FAILURE: {
            return assign({}, state, {
                inventory: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/inventory.ts